  
  const sports = {
    soccer: {
      id: "soccer",
      name: "Soccer"
    },
    baseball: {
      id: "baseball",
      name: "Baseball"
    },
    basketball: {
      id: "basketball",
      name: "Basketball"
    },
    football: {
        id: "football",
        name: "Football"
      },
      golf: {
        id: "golf",
        name: "Golf"
      },
      lacrosse: {
        id: "lacrosse",
        name: "Lacrosse"
      },
      softball: {
        id: "sotball",
        name: "Softball"
      },
      volleyball: {
        id: "volleyball",
        name: "Volleyball"
      },
      wrestling: {
        id: "wrestling",
        name: "Wrestling"
      },
      swimming: {
        id: "swimming",
        name: "Swimming"
      }
  };

  export { sports };


